<mat-slider
  [vertical]="true"
  [thumbLabel]="true"
  [displayWith]="getTranslatedLabel"
  [tickInterval]="1"
  [step]="1"
  [min]="0"
  [max]="floors.length"
  [value]="sliderValue"
  (change)="onChange()"
  (input)="onInput($event.value)"
>
</mat-slider>

<!-- Alert indicators overlay -->
<div class="floor-alerts" *ngIf="floorAlertStates && floorAlertStates.size > 0">
  <ng-container *ngFor="let floor of floors; let i = index">
    <div
      *ngIf="getFloorAlertState(i) as state"
      class="floor-alerts__indicator"
      [style.bottom]="getAlertIndicatorPosition(i)"
      [class.floor-alerts__indicator--active]="true"
      [class.floor-alerts__indicator--critical]="getAlertSeverity(state) === 'critical'"
      [attr.aria-label]="getFloorAlertAriaLabel(floor, state)"
      [attr.title]="getFloorAlertTitle(floor, state)"
      role="status"
    ></div>
  </ng-container>
</div>
